export const ListQueryKey = 'innerTransRecords';
export const DetailQueryKey = 'innerTransRecord';

export const Urls = {
  selectUrl: '/innerTransRecord/list',
  updateUrl: '/innerTransRecord/update',
};
// /api/innerTransRecord/list
